'use client'

import { useEffect, useState } from 'react'
import Tabordion, {
  MobileLayoutType,
  TabordionItemType,
} from '@dustin-web/microsite-components/src/tabordion'
import { Breakpoints } from '@dustin-web/microsite-config'
import { BlogSkeleton } from '../blog-skeleton'

type Props = {
  activeIndex: number[]
  tabordionItems: (TabordionItemType & { summary: string })[]
}

const TabordionWrapper = ({ activeIndex, tabordionItems }: Props) => {
  const [items, setItems] = useState(tabordionItems)
  const [activeTab, setActiveTab] = useState({ loading: false, tabIndex: 0 })

  useEffect(() => {
    setItems(tabordionItems)
    setActiveTab({ ...activeTab, loading: false })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabordionItems])

  useEffect(() => {
    if (!activeTab.loading) {
      return
    }

    const itemsInLoadingState = items.map((item, index) => {
      if (index !== activeTab.tabIndex) {
        return item
      }

      return {
        ...item,
        content: (
          <div className="u-bg-gray-02">
            <div className="container u-py-32">
              <div className="row">
                <div className="col-12 col-lg-9 u-mb-24">
                  <p>{item.summary}</p>
                </div>
                <div className="row col-12 u-pr-0">
                  <BlogSkeleton />
                </div>
              </div>
            </div>
          </div>
        ),
      }
    })

    setItems(itemsInLoadingState)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab.loading])

  return (
    <Tabordion
      mega
      links
      extState
      noContentPadding
      dropdownClassName="u-bg-white"
      mobileLayout={MobileLayoutType.DROPDOWN}
      items={items}
      breakpoint={Breakpoints.LG}
      extActiveTabs={activeIndex}
      onTabChange={tabIndex => setActiveTab({ loading: true, tabIndex })}
    />
  )
}

export default TabordionWrapper
